import _ from 'lodash';

export default function trancate(str: string, len: number) {
  if (!_.isEmpty(str)) {
    return str.length <= len ? str : str.substr(0, len) + '...';
  }
}
